

export const ISSUE_REACTION_EMOJI_CODES = [
  "128077",
  "128078",
  "128516",
  "128165",
  "128533",
  "129505",
  "9992",
  "128064",
];

export const RANDOM_EMOJI_CODES = [
  "8986",
  "9200",
  "128204",
  "127773",
  "127891",
  "128076",
  "128077",
  "128187",
  "128188",
  "128512",
  "128522",
  "128578",
];
